import * as React from 'react'
import {
  IframeSectionContainer,
  Content,
  Iframe
} from './IframeSection.elements'

export type IframeSectionProps = {
  link?: string
}

export const IframeSection: React.FunctionComponent<IframeSectionProps> = ({ link }) => (
  <IframeSectionContainer>
    <Content>
      <Iframe src={link} />
    </Content>
  </IframeSectionContainer>
)
